import { ChangeEvent, forwardRef } from 'react';

import { InputText } from '@eneco/sparky';
import { InputTextProps } from '@eneco/sparky/types';

/**
 * InputText that strips non-digit characters. Keeps text styling (not native number input).
 * Compatible with react-hook-form `register()`.
 */
export const InputDigits = forwardRef<HTMLInputElement, InputTextProps>(
  ({ onChange, inputMode = 'numeric', ...props }, ref) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      const digitsOnly = event.target.value.replace(/\D/g, '');
      if (event.target.value !== digitsOnly) {
        event.target.value = digitsOnly;
      }
      onChange?.(event);
    };

    return <InputText ref={ref} {...props} inputMode={inputMode} onChange={handleChange} />;
  },
);
